import { render } from "./Records.vue?vue&type=template&id=39fe735c&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"

import "./Records.vue?vue&type=style&index=0&id=39fe735c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fe735c"]])

export default __exports__